import React, { useState } from 'react';
import PropTypes from 'prop-types';

import BlockbriefComparisonTable from './BlockbriefComparisonTable';
import ProductPackage from '../reusable/ProductPackage';

/**
 * BlockbriefProductPackage.
 * Page for product.
 *
 * @author  Manny
 * @param   {Object}      props.coupon          Coupon object.
 * @param   {Function}    props.onSelectPackage Handles onClick for selecting a package.
 * @param   {Number}      props.productId       Id number of the product.
 * @param   {Object}      props.productsConfig  Product configurations.
 * @returns {JSX.Element} The component markup.
 */

const BlockbriefProductPackage = ({
  coupon,
  onSelectPackage,
  productId,
  productsConfig
}) => {
  const [activeKey, setActiveKey] = useState(
    productsConfig ? Object.keys(productsConfig.packages).length.toString() : ''
  );
  const [packageKey, setPackageKey] = useState(
    productsConfig
      ? Object.keys(productsConfig.packages)[Object.keys(productsConfig.packages).length - 1]
      : ''
  );

  const productTable = productsConfig ? (
    <BlockbriefComparisonTable
    features={productsConfig.features}
    industryPackage={productsConfig.packages}
    packageKey={packageKey}
  />
  ) : (
    ''
  )

  const productTableMobile = productsConfig ? (
    <BlockbriefComparisonTable
    features={productsConfig.features}
    industryPackage={productsConfig.packages}
    isMobile={true}
    packageKey={packageKey}
  />
  ) : (
    ''
  )


  const productPackage = {
    packageHeader: 'Blockbrief Premier',
    productId: productId,
    productName: 'blockbrief',
    table: productTable,
    tableMobile: productTableMobile
  };

return (
    <ProductPackage
      activeKey={activeKey}
      coupon={coupon}
      onSelectPackage={onSelectPackage}
      packageKey={packageKey}
      productPackage={productPackage}
      productsConfig={productsConfig}
      setActiveKey={setActiveKey}
      setPackageKey={setPackageKey}
    />
  );
};

BlockbriefProductPackage.propTypes = {
  coupon: PropTypes.object,
  onSelectPackage: PropTypes.func.isRequired,
  productId: PropTypes.number,
  productsConfig: PropTypes.object
};

export default BlockbriefProductPackage;
